<template>
  <div class="carousel">
    <div class="carousel-inner">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="carousel-item"
        :class="{ active: index === currentIndex }"
      >
        <img :src="slide" :alt="1" style="object-fit: contain;width: 100%;height: 100%" />
      </div>
    </div>
    <button class="carousel-control prev" @click="prevSlide">&#10094;</button>
    <button class="carousel-control next" @click="nextSlide">&#10095;</button>
  </div>
</template>

<script>
  export default {
    name: 'Carousel',
    props: {
      slides: {
        type: Array,
        required: true,
      },
      interval: {
        type: Number,
        default: 3000, // 默认间隔时间为3秒
      },
    },
    data() {
      return {
        currentIndex: 0,
        timer: null,
      };
    },
    mounted() {
      // this.startAutoPlay();
    },
    beforeDestroy() {
      this.stopAutoPlay();
    },
    methods: {
      startAutoPlay() {
        this.timer = setInterval(this.nextSlide, this.interval);
      },
      stopAutoPlay() {
        if (this.timer) {
          clearInterval(this.timer);
        }
      },
      nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      },
      prevSlide() {
        this.currentIndex =
          (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      },
    },
  };
</script>

<style scoped lang="scss">
  .carousel {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: auto;
    overflow: hidden;
  }

  .carousel-inner {
    width: 500px;
    height: 500px;
    display: flex;
    transition: transform 0.5s ease;
  }

  .carousel-item {
    min-width: 100%;
    box-sizing: border-box;
    display: none;
  }

  .carousel-item.active {
    display: block;
    margin-left: 50px;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
  }

  .carousel-control.prev {
    left: 10px;
  }

  .carousel-control.next {
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue